import React, { useCallback } from 'react';
import PT from 'prop-types';
import cn from 'classnames';

const PaginationButton = ({ label, active, disabled, onClick, dataTestId }) => {
  const handleButtonClick = useCallback(() => {
    onClick(label);
  }, [onClick, label]);

  const content = typeof label === 'number' ? label : null;

  return (
    <button
      onClick={handleButtonClick}
      className={cn('pagination__button', {
        pagination__button_active: active,
        pagination__button_left: label === 'left',
        pagination__button_right: label === 'right',
      })}
      data-testid={dataTestId}
      disabled={disabled}
    >
      {content}
    </button>
  );
};

PaginationButton.propTypes = {
  label: PT.oneOfType([PT.string, PT.number]),
  active: PT.bool,
  onClick: PT.func,
};

export default PaginationButton;
